<template>
  <div></div>
</template>

<script>
export default {
  data() {
    return {
      websock: null
    };
  },
  created() {
    //页面刚进入时开启长连接
    this.initWebSocket();
  },
  destroyed: function() {
    //页面销毁时关闭长连接

    this.$http
      .post(this._Global.HTTP_SERVER + "/webSocket/close", {
        token: this.getToken()
      })
      .then(response => {
        console.log(response.body);
      });

    this.websocketclose();
  },
  methods: {
    initWebSocket() {
      //初始化weosocket
      const wsuri = this._Global.WEB_SOCKET_SERVER + "/webSocket/message"; //ws地址
      this.websock = new WebSocket(wsuri);
      this.websock.onopen = this.websocketonopen;

      this.websock.onerror = this.websocketonerror;

      this.websock.onmessage = this.websocketonmessage;
      this.websock.onclose = this.websocketclose;
    },

    websocketonopen() {
      console.log("WebSocket连接成功");
      var protocol = { opt: 1, token: this.getToken() };
      var jsonData = JSON.stringify(protocol);
      this.websock.send(jsonData);
    },
    websocketonerror(e) {
      //错误
      console.log("WebSocket连接发生错误");
    },
    websocketonmessage(message) {
      this.$emit("webSocketHandle", message.data);
    },

    websocketsend(agentData) {
      //数据发送
    },

    websocketclose(e) {
      //关闭
      console.log("connection closed (" + e.code + ")");
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/WebSocket.vue